import { useState } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import { compressFile } from "src/helpers/mixins";
import Notify from "src/toast/Notify";
import DialogInfoGeneral from "./DialogInfoGeneral";
import { BiSolidCloudUpload } from "react-icons/bi";
import { FaArrowDownLong } from "react-icons/fa6";
import APIService from "src/services/Api";
import { UseAuth } from "src/auth/AuthContext";
import { FaCheckCircle } from "react-icons/fa";

type ParamsUploadMF = {
  type: string;
  text?: string
  transferId: string
  newStatus?: string
  success(): void
  currentStatus: string
  setLoadingUpload(val:boolean):void
};
type IPreview = {
  type: string;
  url: string;
  size: number;
  name: string;
  
};

const DepositUploadManyFiles: React.FC<ParamsUploadMF> = ({ currentStatus,text,type,transferId,newStatus,success,setLoadingUpload}) => {
  const { user } = UseAuth()
  const [files, setFiles] = useState<File[]>([]);
  const [drag, setDrag] = useState(false)
  const [preview, setPreview] = useState<IPreview[]>([]);
  const [showAlertMaxFile, setShowAlertMaxFile] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false)
  const [localSuccess, setLocalSuccess] = useState<boolean>(false)

  const handleUpload = async() => {
    try{
      setLoading(true)
      setLoadingUpload(true)
      const data = new FormData() as any
      data.append('fileOne',files[0] as any)
      data.append('fileTwo',files[1] as any)
      data.append('fileThree',files[2] as any)
      data.append('responsable',user?.role || '')
      data.append('status','checking')
      data.append('transferId',transferId)
      if(newStatus!==currentStatus && newStatus!==undefined){
        data.append('newstatus',newStatus)
      }
      data.append('type',type || '')
      const res = await APIService.transferUploadManyFiles(data)

      if(res?.data?.status){
        setLocalSuccess(true)
        success()
      }else{
        Notify('No fue posible enviar los comprobantes de pago.')
      }
    }catch(e){
      console.log(e)
      Notify('Lo sentimos no es posible enviar los comprobantes de pago.')
    }finally {
      setLoading(false)
      setLoadingUpload(false)
    } 
  }


  const generatePreview = (filesGot: File[]) => {

    setDrag(false)
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    let tempFiles = [] as any;
    let tempPreview: IPreview[] = [];
    const spacesAvailable = files.length === 0 ? 3 : 3 - files.length 
    if (files.length < 3) {
      filesGot = filesGot.slice(0,spacesAvailable)
      filesGot.forEach((file) => {
        const type = file.type;
  /*       console.log("type de archivo es ", type);
        console.log("FILE ES ", file); */

        if (allowedTypes.includes(type)) {
          const compress = type.toString().toLowerCase().includes("image")
          ? compressFile(file)
          : file;
          tempPreview.push({
          type,
          url: URL.createObjectURL(compress ? compress : file),
          size: file.size / 1024 ** 2,
          name: file.name,
          });
          tempFiles.push(compress ? compress : file);
        }else{
          Notify(
            "Solo aceptamos imágenes (PNG, JPG)",
            "error"
          );
        }
      
      });
      setFiles([...files, ...tempFiles]);
      setPreview([...preview, ...tempPreview]);
    } else {
      setShowAlertMaxFile(true);
    }
  };
  const onDrop = (acceptedFiles: any) => {
    generatePreview(acceptedFiles);
  };

  const removeFile = (i: number) => {
    setPreview(preview.filter((_: any, key: number) => key !== i));
    setFiles(files.filter((_: File, key: number) => key !== i));
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles: 3,
    onDragEnter: () => {setDrag(true)},
    onDragLeave: () => {setDrag(false)},
  });

  return (
    <div>
        <>
        {(files.length < 3 && !loading )&& 
          <div {...getRootProps()}>
              <input {...getInputProps()} />
              <div className="w-full text-center mx-auto border-2 py-4 border-green-admin-light mb-2 mt-3 rounded-sm border-dashed flex flex-col justify-center items-center cursor-pointer">
        
                <div className="px-6 text-base py-2 opensans font-semibold">
                  Arrastra y suelta los comprobantes de pago aquí o <button className="bg-yellow-400 text-black px-1 py-0.5 rounded-md">haz clic para seleccionarlos.</button>
                </div>
                {!drag ?
                <>
                  <div className="mt-2 font-semibold text-sm">
                  Máximo 3 imagenes.
                  </div>
                </> 
                :
                <div className="font-medium text-center text-xl py-4">
                  Suelta el archivo 
                  <div className="flex items-center justify-center">
                    <FaArrowDownLong size={40} className="floating text-green-admin-light" />
                  </div>
                </div>
              }
              </div>
          </div>
        }
          {files.length > 0 && (
              <div className="text-center flex flex-col justify-center gap-2 mt-2 mb-3">
                {!localSuccess && 
                  <div>
                      <button onClick={() => handleUpload()} className="bg-yellow-400 text-base font-medium mt-2 text-black px-4 py-2 rounded-xl mt-2">
                      {!loading ? 
                        <>
                          Enviar comprobante{files.length > 1 && "s"}
                        </>
                      :
                      <div className="text-center flex justify-center px-10 py-1">
                        <div className="loader-dots"></div>
                      </div>
                        }
                      </button>
                  </div>
                }
              </div>
            )}
          <div className="bg-gradient-card mb-2 flex flex-col items-center gap-2 py-4 rounded-md border border-stone-400">
            
            {preview?.length > 0 && 
              <div className="grid grid-cols-1 md:grid-cols-3 px-4 py-2 gap-4">
                {preview.map((p, i) => (
                  <div key={p + i.toString()} className="grid-col-1 relative">
                    {!loading && !localSuccess &&  
                      <div
                        onClick={() => removeFile(i)}
                        className="cursor-pointer rounded-full absolute -right-2 -top-3 bg-red-500 text-white w-6 h-6 flex items-center justify-center font-bold"
                      >
                        X
                      </div>
                    }
                    {p.type.toLocaleLowerCase().includes("image") && (
                      <div
                        className="w-full h-20 rounded-md bg-image-complete border border-stone-400 "
                        style={{
                          background: `url(${p.url})`,
                          backgroundPosition: "center",
                        }}
                      ></div>
                    )}
                    <div className="my-1 text-xs font-bold">
                      {/*<div>{p.name}</div> */}
                      Tamaño {Number(p.size).toFixed(2)} MB
                    </div>
                  </div>
                ))}
              </div>
            }
            <div className="font-semibold text-center text-sm opensans px-4">
              {!text
                ? <div>
                    {currentStatus === 'refused' ? 
                      <div>
                        Has rechazado la transferencia.
                        <div>
                          ¿Quieres enviar una imagen como comprobante?
                        </div>
                      </div>
                    :
                      <div>
                        <div className="">
                          <div className="bg-white font-bold px-4 rounded-md text-red-600 w-fit mx-auto">
                            Advertencia
                          </div>
                          <div>
                            Enviar comprobantes de pago falsos resultará en la pérdida de sus fondos y el bloqueo permanente de su cuenta.
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                : 
                text}
            </div>

          </div>

        </>      
      
      {localSuccess && 
        <div className="px-4 py-4">
          <div className="text-center text-xl px-4 flex items-center justify-center gap-2 mb-4">
            ¡ Genial !
            <FaCheckCircle size={22} className="text-green-admin-light" />
          </div>
          
          <div className="text-lg text-center ">
            Las imágenes se han cargado con éxito.
          </div>
        </div>
      
      }
      
      
      <ToastContainer
        position="bottom-center"
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {showAlertMaxFile && 
        <div>
          <DialogInfoGeneral 
            show={showAlertMaxFile} 
            closeDialog={ () => setShowAlertMaxFile(false)}
          > 
          <div className="text-center text-base px-8 py-12 font-medium">
            Has alcanzado el límite máximo de 3 imágenes. 
            <div>
              Si deseas subir más, elimina alguna de las imágenes actuales.
            </div>
          </div>
          </DialogInfoGeneral>
        </div>
      }
    </div>
  );
};

export default DepositUploadManyFiles;
